import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/$")({
  head: () => appTitleHead("not-found-title"),
  component: NotFoundPage
});
